<app-header [forceLightBackground]="true"></app-header>

<!-- Loading State -->
<div class="consumer-dashboard--loading" *ngIf="isChecking">
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p>Loading dashboard...</p>
  </div>
</div>

<!-- Dashboard Content -->
<div class="consumer-dashboard" *ngIf="canAccess && !isChecking">
  <div class="consumer-dashboard--layout">
    <app-consumer-sidebar class="consumer-dashboard--sidebar"></app-consumer-sidebar>
    <div class="consumer-dashboard--content">
      <div class="page-container">
        <app-dataset-provider-dashboard></app-dataset-provider-dashboard>
      </div>
    </div>
  </div>
</div>
